<template>
  <div class="custom-field-timestamp flex-1 align-baseline">
    <div class="component-item">
      <date-picker
        v-model="customDate"
        field-min-width="175px"
        :placeholder="t('customFields.select_date')"
        :test-id="`${toKebabCase(field.label)}-date-picker`"
        compact-display
        :display-field-label="false"
        :display-field-icon="false"
        :required="field.required"></date-picker>
    </div>
    <div class="component-item">
      <time-entry
        :test-id="`${toKebabCase(field.label)}-time-entry`"
        :date="dateTime"
        :warehouse="warehouse"
        :military-time-enabled="$isMilitaryTimeEnabled(warehouse)"
        v-model="customTime"
        :fontSizeLarge="false"
        :required="field.required"
        :compact="isMobile()"
        inline></time-entry>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import customFieldTypeMixinOld from '@/modules/custom_fields/mixins/customFieldTypeMixinOld';
import { toDateTime, t, toKebabCase, LuxonDateTimeFormats } from '@nova/core';
import { isMobile } from '@satellite/plugins/util';

export default {
  name: 'custom-field-timestamp-old',
  mixins: [customFieldTypeMixinOld],
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      customTime: {
        amPm: '',
        time: ''
      },
      customDate: ''
    };
  },
  computed: {
    dateTime() {
      if (!this.customDate || !this.customTime.time || !this.customTime.amPm) {
        return null;
      }
      const parsedDate = DateTime.fromISO(this.customDate);
      const dateStr = parsedDate.isValid ? parsedDate.toFormat('yyyy-MM-dd') : this.customDate;
      const newDateTimeString = [dateStr, this.customTime.time, this.customTime.amPm].join(' ');
      const newDateTime = DateTime.fromFormat(newDateTimeString, 'yyyy-MM-dd hh:mm a', {
        zone: this.warehouse.timezone
      });
      return newDateTime?.isValid ? newDateTime : null;
    }
  },
  methods: {
    t,
    toKebabCase,
    isMobile,
    emitValueUpdate(value) {
      if (this.field.required && !value) {
        return null;
      }
      this.$emit('update:model-value', this.dateTime?.isValid ? this.dateTime.toISO() : null);
    }
  },
  beforeMount() {
    if (this.value) {
      try {
        const currentDate = toDateTime(this.value, { zone: this.warehouse.timezone });

        if (currentDate?.isValid) {
          this.customDate = currentDate.toFormat(LuxonDateTimeFormats.DateDashed);
          this.customTime.time = currentDate.toFormat(LuxonDateTimeFormats.Extended12HrTimePadding);
          this.customTime.amPm = currentDate.toFormat('a').toLowerCase();
        }
      } catch {
        // Malformed persisted value: leave empty fields (same as invalid Moment parse)
      }
    }
  },
  watch: {
    value() {
      return false;
    },
    customDate(value) {
      this.emitValueUpdate(value);
    },
    customTime(value) {
      this.emitValueUpdate(value);
    }
  }
};
</script>
<style lang="scss">
.custom-field-timestamp {
  display: flex;
  gap: 1rem;
}
.is-mobile {
  .custom-field-timestamp {
    display: block;
    .component-item {
      margin-bottom: 5px !important;
      .v-input,
      .v-input-control {
        margin: 0 !important;
        padding-top: 5px !important;
        align-items: flex-start !important;
      }
    }
  }
}
</style>
